<template>
  <div>
    <!-- Chiffres clés (TrustBand) -->
    <v-row class="mb-8" justify="center">
      <v-col v-for="stat in stats" :key="stat.label" cols="6" sm="auto" class="text-center px-6">
        <v-img v-if="stat.img" :src="stat.img" contain max-height="32px" class="mx-auto mb-1"></v-img>
        <div v-else class="text-h5 font-weight-black primary--text">{{ stat.num }}</div>
        <div class="text-caption grey--text text--darken-1">{{ stat.label }}</div>
      </v-col>
    </v-row>

    <v-divider class="mb-8"></v-divider>

    <!-- Mission -->
    <v-row class="text-left">
      <v-col cols="12" sm="6" md="5" class="d-flex align-center">
        <div>
          <p class="mb-0">Notre mission :</p>
          <p class="font-weight-bold text-h6 mt-2">
            Accompagner la transition alimentaire dans les assiettes et les filières agricoles
          </p>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="7" class="pl-md-8">
        <p>Labricot résout les problèmes quotidiens de la restauration collective :</p>
        <ul class="no-bullets">
          <li class="mt-3">
            <v-icon color="grey darken-3" class="mr-2">$newspaper-fill</v-icon>
            <strong>Absences non remontées</strong>
            — les effectifs sont synchronisés école ↔ cuisine, en 1 clic par le référent scolaire.
          </li>
          <li class="mt-3">
            <v-icon color="grey darken-3" class="mr-2">$restaurant-fill</v-icon>
            <strong>Quantités estimées à l'aveugle</strong>
            — le calibrage des portions s'appuie sur l'historique réel de consommation.
          </li>
          <li class="mt-3">
            <v-icon color="grey darken-3" class="mr-2">$team-fill</v-icon>
            <strong>EGAlim source d'angoisse</strong>
            — tableaux de bord prêts à l'emploi et aide à la télédéclaration sur macantine.gouv.fr.
          </li>
        </ul>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "MissionBlock",
  data() {
    return {
      stats: [
        { num: null, img: "/static/images/etincelle_gouv.png", label: "Lauréat 2024" },
        { num: "18 M€", img: null, label: "CA Groupe Labsoft" },
        { num: "220", img: null, label: "collaborateurs" },
        { num: "24 ans", img: null, label: "d'expérience" },
        { num: "−12%", img: null, label: "gaspillage moyen constaté" },
      ],
    }
  },
}
</script>
